var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitToApp24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#8894de;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.79,16.29a1,1,0,0,0,1.41,0l3.59-3.59a1,1,0,0,0,0-1.41L12.2,7.7a1,1,0,0,0-1.41,1.41L12.67,11H4a1,1,0,0,0,0,2h8.67l-1.88,1.88A1,1,0,0,0,10.79,16.29ZM19,3H5A2,2,0,0,0,3,5V8A1,1,0,0,0,5,8V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V16a1,1,0,0,0-2,0v3a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitToApp24Px);
export default __webpack_public_path__ + "static/media/exit_to_app-24px.55b6afa7d9e4d977fbd5158b93f979b3.svg";
export { ForwardRef as ReactComponent };